const doc = [({"en":({"js":({"nemoa":({"activities":({"show":({"nav":({"overview":"Overview", "live":"Live", "politics":"Politics", "election":"Election"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;